import { Component, OnDestroy, OnInit } from '@angular/core';
import { AllSizesImageDO, PostDO } from '../../common/data-objects/PostDO';
import { PostsService } from '../../common/services/posts.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { Subscription } from 'rxjs';
import { Utils } from '../../common/utils/Utils';
import { SeoService } from 'src/app/common/services/seo.service';

@Component({
  selector: 'app-single-coloring-page',
  templateUrl: './single-coloring-page.component.html',
  styleUrls: ['./single-coloring-page.component.scss'],
})
export class SingleColoringPageComponent implements OnInit, OnDestroy {
  post: PostDO;
  isLoading: boolean;
  slug: string;
  itemImages: AllSizesImageDO[];
  private paramMapSubscription: Subscription;

  constructor(
    private postsService: PostsService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private sanitizer: DomSanitizer,
    private seoService: SeoService
  ) {
    this.paramMapSubscription = this.activatedRoute.paramMap.subscribe((paramMap) => {
      this.slug = paramMap.get('slug');
    });
  }

  ngOnInit() {
    this.getData();
  }

  ngOnDestroy(): void {
    if (this.paramMapSubscription) {
      this.paramMapSubscription.unsubscribe();
    }
  }

  private getData() {
    this.isLoading = true;
    this.postsService.getPostBySlug(this.slug).subscribe((post) => {
      this.post = post;
      const title = `${Utils.removeUnicode(this.post.title.rendered)} - Fun Bible`;
      this.seoService.setTitle(title);
      this.itemImages = this.post.allSizesImages;
      this.isLoading = false;
      this.seoService.setDescription(`Planșe de colorat despre ${post.title.rendered}`);
      this.meta.updateTag({ property: 'og:url', content: `https://funbible.net/coloring/${post.slug}?id=${post.id}` });
      this.meta.updateTag({
        property: 'og:image',
        content: this.post.featuredImage ? this.post.featuredImage : 'https://funbible.net/assets/logo.jpg'
      });
      const initialKeywords = ['culori', 'planse de colorat biblice', 'imagini de colorat', 'fise de colorat crestine', 'plansa de colorat'];
      const dynamicKeywords = this.post.excerptTags.slice(0, 5);
      const finalKeywords = [...initialKeywords, ...dynamicKeywords].join();
      this.meta.updateTag({property: 'keywords', content: finalKeywords});

      this.angulartics2.eventTrack.next({
        action: post.title.rendered,
        properties: { category: 'pageView' },
      });
    }, () => {
      this.toastr.error('Acest conținut nu există!');
      this.isLoading = false;
    });
  }

  get postImage(): string {
    return `url(${this.post.featuredImageSizes.full ? this.post.featuredImageSizes.full : 'assets/logo.svg'})`;
  }

  get sanitizedContent(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.onlyText);
  }

  get onlyText(): string {
    return this.post.content.rendered.replace(/([\s\S]*?)<figure[\s\S]*$/, '$1');
  }
}
